import { userServiceClient } from '@/service/lib/user';

export interface UserInfo {
  id: number;
  /** 是否是内部用户 */
  is_internal: boolean;
  /** 是否是bpo用户 */
  is_bpo: boolean;
  user_type: number;
  username: string;
  nickname: string;
  email: string;
  avatar_url: string;
}

/** 获取登录用户的信息 */
export const getUserInfo = () => {
  return userServiceClient
    .Self({})
    .then(({ user, default_project_id, demo_project_id }) => ({
      userInfo: {
        id: user?.user_id,
        type: user?.user_type,
        username: user?.username,
        nickname: user?.nickname,
        email: user?.email,
        avatar: user?.avatar_url,
        isInternal: user?.is_internal,
        isBpo: user?.is_bpo,
        openId: user?.open_id,
        userType: user?.user_type,
      },
      defaultProjectID: default_project_id || demo_project_id,
    }));
};
